import { render, staticRenderFns } from "./RELEmbarques.vue?vue&type=template&id=dfa59e96&"
import script from "./RELEmbarques.vue?vue&type=script&lang=js&"
export * from "./RELEmbarques.vue?vue&type=script&lang=js&"
import style0 from "./RELEmbarques.vue?vue&type=style&index=0&id=dfa59e96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports